export enum ShipMethodEnums {
   pickupOrder= "ORDPCK"
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/shipmethod.enums.ts